import {
	Autocomplete,
	Button,
	FormControl,
	FormControlLabel,
	FormLabel,
	Grid,
	InputLabel,
	LinearProgress,
	MenuItem,
	Paper,
	Radio,
	RadioGroup,
	Select,
	TextField,
	ThemeProvider,
	Tooltip,
	Typography,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import RemoveIcon from "@mui/icons-material/Remove";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useEffect, useState } from "react";
import {
	getSistemasRoles
} from "../../../services/SistemaRolService";
import { getSistemas } from "../../../services/SistemaService";
import SistemaRolOrganismoUsuarioDialog from "./SistemaRolOrganismoUsuarioDialog";
import Message from "../../../utils/Message";
import { Box } from "@mui/system";
import { getSistemaRolOrganismoUsuario, getSistemasRolesOrganismosUsuarios } from "../../../services/SistemaRolOrganismoUsuarioService";
import { getUsuariosOrganismosAreasFunciones } from "../../../services/UsuarioOrganismoAreaFuncionService";
import { getOrganismos } from "../../../services/OrganismoService";
import { getFueros } from "../../../services/FueroService";

import React from 'react';
import { id } from "date-fns/locale";


const initialSearchData = {
	descripcion: "",
	estado: "habilitado",
	orden: "ASC",
	ordenarPor: "descripcion_sistema",
	circunscripcionJudicial: "todo",
	idFuero: "",
};

const estadoOptions = [
	{
		id: "todo",
		descripcion: "Todo",
	},
	{
		id: "habilitado",
		descripcion: "Habilitado",
	},
	{
		id: "deshabilitado",
		descripcion: "Deshabilitado",
	},
];

const ordenOptions = [
	{
		id: "ASC",
		descripcion: "Ascendente",
	},
	{
		id: "DESC",
		descripcion: "Descendente",
	},
];

const ordenarPorOptions = [
	{
		id: "descripcion_sistema",
		descripcion: "Sistema",
	},
	{
		id: "descripcion_sistema_rol",
		descripcion: "Rol",
	},
	{
		id: "username_usuario",
		descripcion: "Usuario",
	},
	{
		id: "descripcion_organismo",
		descripcion: "Organismo",
	},
];

const circunscripcionJudicialOptions = [
	{
		id: "todo",
		descripcion: "Todas",
	},
	{
		id: "1",
		descripcion: "Primera",
	},
	{
		id: "2",
		descripcion: "Segunda",
	},
	{
		id: "3",
		descripcion: "Tercera",
	},
	{
		id: "4",
		descripcion: "Cuarta",
	}
];

const nameItemsText = "Asignación de Roles a Usuarios de Sistemas por Organismo";
//
// #####################################################################################################################
//
const SistemaRolOrganismoUsuarioTable = (data) => {
	const [searchData, setSearchData] = useState(initialSearchData);
	const [itemsCrud, setItemsCrud] = useState([]);
	const [itemCrud, setItemCrud] = useState({});
	const [actionCrud, setActionCrud] = useState("");
	const [isDoingSomething, setIsDoingSomething] = useState(false);
	const [openDialog, setOpenDialog] = useState(false);
	const [totalRowsCount, setTotalRowsCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [message, setMessage] = useState({});
	const [showMessage, setShowMessage] = useState(false);
	const [sistemas, setSistemas] = useState([]);
	const [sistemasRoles, setSistemasRoles] = useState([]);
	const [usuarios, setUsuarios] = useState([]);
	const [valueAutoCompleteSistemas, setValueAutoCompleteSistemas] = useState({
		id: "",
		label: "",
	});
	const [inputValueAutoCompleteSistemas, setInputValueAutoCompleteSistemas] =
		useState("");
	const [valueAutoCompleteSistemasRoles, setValueAutoCompleteSistemasRoles] = useState({
		id: "",
		label: "",
	});
	const [inputValueAutoCompleteSistemasRoles, setInputValueAutoCompleteSistemasRoles] =
		useState("");

	const [valueAutoCompleteUsuarios, setValueAutoCompleteUsuarios] = useState({
		id: "",
		label: "",
		idSistemaRol: ""
	});
	const [inputValueAutoCompleteUsuarios, setInputValueAutoCompleteUsuarios] =
		useState("");
	const [fueros, setFueros] = useState([]);
	const [valueAutoCompleteFuero, setValueAutoCompleteFuero] = useState({
		id: "",
		label: "",
	});
	const [inputValueAutoCompleteFuero, setInputValueAutoCompleteFuero] = useState("");
	const [organismos, setOrganismos] = useState([]);
	const [valueAutoCompleteOrganismo, setValueAutoCompleteOrganismo] = useState({
		id: "",
		label: "",
	});
	const [inputValueAutoCompleteOrganismo, setInputValueAutoCompleteOrganismo] = useState("");

	const circunscripcionMap = circunscripcionJudicialOptions.reduce((map, option) => {
		map[option.id] = option.descripcion;
		return map;
	}, {});

	const tableColumns = [
		{
			name: "id",
			label: "ID",
			options: {
				display: "excluded",
			},
		},
		{
			name: "descripcion_sistema",
			label: "Sistema",
			options: {
				filter: false,
				sort: false,
			},
		},
		{
			name: "descripcion_sistema_rol",
			label: "Rol",
			options: {
				filter: false,
				sort: false,
			},
		},
		{
			name: "descripcion_organismo",
			label: "Organismo",
			options: {
				filter: false,
				sort: false,
			},
		},
		{
			name: "username_usuario",
			label: "Usuario",
			options: {
				filter: false,
				sort: false,
			},
		},
		{
			name: "actions",
			label: "Acciones",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRenderLite: (dataIndex, rowIndex) => (
					<>
						{itemsCrud[dataIndex].habilitado && (
							<Tooltip title="Deshabilitar">
								<IconButton
									size="small"
									aria-label="disable"
									onClick={() =>
										handleClickActionCrud(itemsCrud[dataIndex], "disable")
									}
								>
									<RemoveIcon />
								</IconButton>
							</Tooltip>
						)}

						{!itemsCrud[dataIndex].habilitado && (
							<Tooltip title="Habilitar">
								<IconButton
									size="small"
									aria-label="enable"
									onClick={() =>
										handleClickActionCrud(itemsCrud[dataIndex], "enable")
									}
								>
									<AddIcon />
								</IconButton>
							</Tooltip>
						)}

						{(
							<Tooltip title="Ver">
								<IconButton
									size="small"
									aria-label="read"
									onClick={() => handleClickActionCrud(itemsCrud[dataIndex], "read")}
								>
									<ZoomInIcon />
								</IconButton>
							</Tooltip>
						)}
					</>
				),
			},
		},
	];

	const tableOptions = {
		storageKey: "my-table-state",
		rowsPerPageOptions: [10, 20, 30],
		serverSide: true,
		count: totalRowsCount,
		rowsPerPage: rowsPerPage,
		onChangeRowsPerPage: (numberOfRows) => {
			setRowsPerPage(numberOfRows);
		},
		onChangePage: (currentPage) => {
			setCurrentPage(currentPage);
		},
		download: false,
		filter: false,
		print: false,
		search: false,
		viewColumns: false,
		selectableRowsHeader: false,
		selectableRows: "none",
		elevation: 5,
		textLabels: {
			body: {
				noMatch: "No se encuentran resultados para esta búsqueda",
			},
			pagination: {
				next: "Próxima",
				previous: "Previa",
				rowsPerPage: "Filas:",
				displayRows: "de",
			},
		},
	};
	//
	// ################################################################################ 
	//

	useEffect(() => {
		const loadSistemas = async () => {
			setIsDoingSomething(true);
			const response = await getSistemas({ estado: "habilitado" });
			setIsDoingSomething(false);

			if (response.ok) {
				let _response = response.data.data;
				let _sistemas = [];

				_response.forEach((item) => {
					_sistemas.push({
						id: item.id,
						label: item.descripcion,
					});
				});

				setSistemas(_sistemas);
				setSistemasRoles([])

			} else {
				setSistemas([]);
				setMessage({
					messageText: response.messageText,
					severity: response.messageSeverity,
				});
				setShowMessage(true);
			}
		};
		loadSistemas();
	}, []);
	//
	// ################################################################################
	//
	useEffect(() => {
		load();
	}, [currentPage, rowsPerPage]);
	//
	// ################################################################################
	//
	useEffect(() => {
		setValueAutoCompleteSistemasRoles({
			id: "",
			label: "",
		});
		setValueAutoCompleteUsuarios({
			id: "",
			label: "",
		});
	}, [valueAutoCompleteSistemas]);
	//
	// ################################################################################
	//
	const handleChange = (e) => {
		setSearchData({
			...searchData,
			[e.target.name]:
				e.target.type === "checkbox" ? e.target.checked : e.target.value,
		});
	};
	//
	// ################################################################################
	//
	const handleLimpiar = () => {

		setValueAutoCompleteSistemas({
			id: "",
			label: "",
		});
		setInputValueAutoCompleteSistemas("");
		setValueAutoCompleteSistemasRoles({
			id: "",
			label: "",
		});
		setInputValueAutoCompleteSistemasRoles("");
		setValueAutoCompleteUsuarios({
			id: "",
			label: "",
		});
		setInputValueAutoCompleteUsuarios("");
		setValueAutoCompleteFuero({
			id: "",
			label: "",
		});
		setInputValueAutoCompleteFuero("");
		setValueAutoCompleteOrganismo({
			id: "",
			label: "",
		});
		setInputValueAutoCompleteOrganismo("");
		setSearchData(initialSearchData);
		setItemsCrud([]);
		setSistemasRoles([]);
	};
	//
	// ################################################################################
	//

	const handleBuscar = () => {
		setCurrentPage(0);
		load();
		loadRoles();
		//loadUsuarios();
	};
	//
	// ################################################################################
	//
	const load = async () => {
		let _params = {
			idSistema: valueAutoCompleteSistemas?.id,
			idRol: valueAutoCompleteSistemasRoles?.id,
			idUsuario: valueAutoCompleteUsuarios?.id,
			idOrganismo: valueAutoCompleteOrganismo?.id,
			estado: searchData.estado,
			sortOrder: searchData.orden,
			sortField: searchData.ordenarPor,
			rows: rowsPerPage,
			first: currentPage * rowsPerPage,
		};
		setIsDoingSomething(true);
		const response = await getSistemasRolesOrganismosUsuarios(_params);
		setIsDoingSomething(false);
		if (response.ok) {
			setTotalRowsCount(response.data.count);
			setItemsCrud(response.data.data);
		} else {
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadRoles = async (newValue) => {
		let _params = {
			idSistema: newValue?.id || valueAutoCompleteSistemas?.id,
			idRol: newValue?.id,
		};
		setIsDoingSomething(true);
		const response = await getSistemasRoles(_params);
		setIsDoingSomething(false);

		if (response.ok) {
			let _response = response.data.data;
			let _roles = [];
			_response.forEach((item) => {
				_roles.push({
					id: item.id,
					label: item.descripcion_sistema_rol,
				});
			});

			setSistemasRoles(_roles);
		} else {
			setSistemasRoles([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}

	};
	//
	// ################################################################################ 
	//
	const loadUsuarios = async (newValue) => {
		let _params = {
			idSistema: newValue?.id,
		};

		setIsDoingSomething(true);
		const response = await getUsuariosOrganismosAreasFunciones(_params);
		setIsDoingSomething(false);
		if (response.ok) {
			let _response = response.data.data;
			let _usuarios = [];
			_response.forEach((item) => {
				_usuarios.push({
					id: item.id_usuario,
					label: item.apellido_usuario + ', ' + item.nombre_usuario,
				});
			});

			setUsuarios(_usuarios);
		} else {
			setUsuarios([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	useEffect(() => {
		const loadFueros = async () => {
			setIsDoingSomething(true);
			const response = await getFueros({ estado: "habilitado" });
			setIsDoingSomething(false);

			if (response.ok) {
				let _response = response.data.data;
				let _Fueros = [];

				_response.forEach((item) => {
					_Fueros.push({
						id: item.id,
						label: item.descripcion,
					});
				});

				setFueros(_Fueros);
			} else {
				setFueros([]);
				setMessage({
					messageText: response.messageText,
					severity: response.messageSeverity,
				});
				setShowMessage(true);
			}
		};
		loadFueros();
	}, []);


	//
	// ################################################################################
	//

	const loadOrganismos = async (newValue) => {
		let _params = {
			idFuero: newValue?.id || valueAutoCompleteFuero?.id,
			idOrganismo: newValue?.id,
			circunscripcionJudicial: newValue?.circunscripcionJudicial || searchData.circunscripcionJudicial,
		};
		setIsDoingSomething(true);
		const response = await getOrganismos(_params);
		setIsDoingSomething(false);

		if (response.ok) {
			let _response = response.data.data;
			let _Organismos = [];
			_response.forEach((item) => {
				_Organismos.push({
					id: item.id,
					id_fuero: item.id_fuero,
					label: item.descripcion,
				});
			});

			setOrganismos(_Organismos);
		} else {
			setOrganismos([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};


	//
	// ################################################################################
	//
	const handleClickActionCrud = (itemCrud, action) => {
		let _itemCrud = {};

		if (action !== "create") {
			const loadItem = async () => {
				setIsDoingSomething(true);
				const response = await getSistemaRolOrganismoUsuario({ id: itemCrud.id });
				setIsDoingSomething(false);

				if (response.ok) {
					_itemCrud = {
						id: response.data.data.id,
						sistema: {
							id: response.data.data.id_sistema,
							label: response.data.data.descripcion_sistema,
						},
						descripcion: response.data.data.descripcion_sistema_rol,
						observaciones: response.data.data.observaciones_sistema_rol,
						organismo: {
							id: response.data.data.id_organismo,
							label: response.data.data.descripcion_organismo,
						},
						fuero: {
							id: response.data.data.id_fuero,
							label: response.data.data.descripcion_fuero,
						},
						circunscripcionJudicialOrganismo: response.data.data.circunscripcion_judicial_organismo,
						idUsuario: response.data.data.id_usuario,
						fechaCreacion: response.data.data.fecha_creacion,
						fechaActualizacion: response.data.data.fecha_actualizacion,
						nombreUsuario: response.data.data.nombre_usuario,
						apellidoUsuario: response.data.data.apellido_usuario,
						username: response.data.data.username,
						nombreUsuarioActualiza: response.data.data.nombre_usuario_actualiza,
						apellidoUsuarioActualiza: response.data.data.apellido_usuario_actualiza,
						usernameUsuarioActualiza: response.data.data.username_usuario_actualiza,
					};

					setActionCrud(action);
					setItemCrud(_itemCrud);
					setOpenDialog(true);
				} else {
					setMessage({
						severity: response.messageSeverity,
						messageText: response.messageText,
					});
					setShowMessage(true);
					return;
				}
			};
			loadItem();
		} else {
			setActionCrud(action);
			setItemCrud(_itemCrud);
			setOpenDialog(true);
		}
	};

	const handleFueroChange = (event, newValue) => {
		setValueAutoCompleteFuero(newValue);
		setSearchData({
			...searchData,
			idFuero: newValue?.id || '',
		});
		loadOrganismos(newValue);
	};

	//
	// ################################################################################
	//

	const handleCircunscripcionChange = (event) => {
		const newValue = event.target.value;
		setSearchData({
			...searchData,
			circunscripcionJudicial: newValue,
		});
		loadOrganismos({ circunscripcionJudicial: newValue });
	};

	//
	// ################################################################################
	//

	const handleDialogSave = () => {
		load();
		setOpenDialog(false);
	};

	//
	// ################################################################################
	//

	const handleDialogClose = () => {
		setOpenDialog(false);
	};

	//
	// ################################################################################
	//

	// const handleGenerarPDF = () => {
	// 	generarPDF();
	// };

	// //
	// // ################################################################################
	// //

	// const generarPDF = async () => {
	// 	let _params = {
	// 		idSistema: valueAutoCompleteSistemas?.id,
	// 		idRol: valueAutoCompleteSistemasRoles?.id,
	// 		idUsuario: valueAutoCompleteUsuarios?.id,
	// 		sortOrder: searchData.orden,
	//     		sortField: searchData.ordenarPor,		
	// 		estado: searchData.estado,
	// 	};

	// 	setIsDoingSomething(true);
	// 	const response = await generarPDFSistemasRolesUsuarios(_params);

	// 	setIsDoingSomething(false);
	// 	if (!response.ok) {
	// 		setMessage({
	// 			messageText: response.messageText,
	// 			severity: response.messageSeverity,
	// 		});
	// 		setShowMessage(true);
	// 	}
	// };

	//
	// ################################################################################
	//
	// let table = data.data.table
	return (
		<>
			<Paper

				elevation={2}
			>
				<Box
					sx={{
						margin: "auto",
						width: "90%",
					}}
				>
					<Box sx={{ m: 1, p: 1 }}>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<h2>{nameItemsText}</h2>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<Autocomplete
									id="sistema"
									size="small"
									value={valueAutoCompleteSistemas}
									onChange={(event, newValue) => {
										setValueAutoCompleteSistemas(newValue);
										setSearchData({
											...searchData,
											idSistema: newValue?.id,
											idSistemaRol: newValue?.id_sistema_rol
										});
										loadRoles(newValue)
										loadUsuarios(newValue)
									}}
									inputValue={inputValueAutoCompleteSistemas}
									onInputChange={(event, newInputValue) => {
										setInputValueAutoCompleteSistemas(newInputValue);
									}}
									options={sistemas}
									renderInput={(params) => (
										<TextField {...params} label="Sistema" />
									)}
									isOptionEqualToValue={(option, value) =>
										option.value === value.value
									}
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<Autocomplete
									id="rol"
									size="small"
									disabled={!valueAutoCompleteSistemas?.id}
									value={valueAutoCompleteSistemasRoles}
									onChange={(event, newValue) => {
										setValueAutoCompleteSistemasRoles(newValue);
										setSearchData({
											...searchData,
											idRol: newValue?.id,
										});
									}}
									inputValue={inputValueAutoCompleteSistemasRoles}
									onInputChange={(event, newInputValue) => {
										setInputValueAutoCompleteSistemasRoles(newInputValue);
									}}
									options={sistemasRoles}
									renderInput={(params) => (
										<TextField {...params} label="Rol" />
									)}
									isOptionEqualToValue={(option, value) =>
										option.value === value.value
									}
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<Autocomplete
									id="usuario"
									size="small"
									disabled={!valueAutoCompleteSistemas?.id}
									value={valueAutoCompleteUsuarios}
									onChange={(event, newValue) => {
										setValueAutoCompleteUsuarios(newValue);
										setSearchData({
											...searchData,
											idSistema: newValue?.id,
											idSistemaRol: newValue?.idSistemaRol
										});
									}}
									inputValue={inputValueAutoCompleteUsuarios}
									onInputChange={(event, newInputValue) => {
										setInputValueAutoCompleteUsuarios(newInputValue);
									}}
									options={usuarios}
									renderInput={(params) => (
										<TextField {...params} label="Usuario" />
									)}
									isOptionEqualToValue={(option, value) =>
										option.value === value.value
									}
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<FormControl sx={{ width: "100%" }}>
									<InputLabel id="estado-select-label">Estado</InputLabel>
									<Select
										sx={{ width: "100%", mr: 1 }}
										labelId="estado"
										label="Estado"
										id="estado"
										name="estado"
										value={searchData.estado}
										size="small"
										onChange={handleChange}
									>
										{estadoOptions.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<Autocomplete
									id="fuero"
									size="small"
									value={valueAutoCompleteFuero}
									onChange={handleFueroChange}
									inputValue={inputValueAutoCompleteFuero}
									onInputChange={(event, newInputValue) => {
										setInputValueAutoCompleteFuero(newInputValue);
									}}
									options={fueros}
									renderInput={(params) => (
										<TextField {...params} label="Fuero" />
									)}
									isOptionEqualToValue={(option, value) =>
										option.value === value.value
									}
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<FormControl sx={{ width: "100%" }}>
									<InputLabel id="circunscripcionJudicial-select-label">Circunscripción Judicial</InputLabel>
									<Select
										sx={{ width: "100%", mr: 1 }}
										labelId="circunscripcionJudicial"
										label="Circunscripción Judicial"
										id="circunscripcionJudicial"
										name="circunscripcionJudicial"
										value={searchData.circunscripcionJudicial}
										size="small"
										onChange={handleCircunscripcionChange}
									>
										{circunscripcionJudicialOptions.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<Autocomplete
									id="organismo"
									size="small"
									disabled={!valueAutoCompleteFuero?.id || searchData.circunscripcionJudicial === "todo"}
									value={valueAutoCompleteOrganismo}
									onChange={(event, newValue) => {
										setValueAutoCompleteOrganismo(newValue);
										setSearchData({
											...searchData,
											idOrganismo:
												newValue === null ? "" : newValue.id,
										});
									}}
									inputValue={inputValueAutoCompleteOrganismo}
									onInputChange={(event, newInputValue) => {
										setInputValueAutoCompleteOrganismo(newInputValue);
									}}
									options={organismos}
									renderInput={(params) => (
										<TextField {...params} label="Organismo" />
									)}
									isOptionEqualToValue={(option, value) =>
										option.value === value.value
									}
								/>
							</Grid>
						</Grid>
					</Box>
					<Box sx={{ m: 1, p: 1 }}>
						<Grid container spacing={1}>
							<Grid item xs={12} md={3}>
								<FormControl sx={{ width: "100%" }}>
									<InputLabel id="ordenarPor-select-label">
										Ordenar por:
									</InputLabel>
									<Select
										sx={{ width: "100%", mr: 1 }}
										labelId="ordenarPor"
										label="Ordenar por:"
										id="ordenaPor"
										name="ordenarPor"
										value={searchData.ordenarPor}
										size="small"
										onChange={handleChange}
									>
										{ordenarPorOptions.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={4}>
								<Grid container spacing={2}>
									<Grid item xs={6}>
										<FormControl component="fieldset">
											<Box display="flex" alignItems="center" sx={{ '& .MuiFormControlLabel-root': { pl: 3 } }}>
												<Typography variant="subtitle1" component="span" sx={{ ml: 1 }}>
													Ordenar
												</Typography>
												<RadioGroup
													aria-label="Orden"
													name="orden"
													value={searchData.orden}
													onChange={handleChange}
													row
												>
													{ordenOptions
														.slice(0, Math.ceil(ordenOptions.length / 2))
														.map((item) => (
															<FormControlLabel
																key={item.id}
																value={item.id}
																label={item.descripcion}
																control={<Radio />}
															/>
														))}
												</RadioGroup>
												<RadioGroup
													aria-label="Orden"
													name="orden"
													value={searchData.orden}
													onChange={handleChange}
													row
												>
													{ordenOptions
														.slice(Math.ceil(ordenOptions.length / 2))
														.map((item) => (
															<FormControlLabel
																key={item.id}
																value={item.id}
																label={item.descripcion}
																control={<Radio />}
															/>
														))}
												</RadioGroup>
											</Box>
										</FormControl>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Box>
					<Box sx={{ m: 1, p: 1 }}>
						<Grid container spacing={1}>
							<Grid item xs={12} md={3} lg={2}>
								<Button
									sx={{ width: "100%" }}
									variant="contained"
									size="small"
									onClick={() => handleClickActionCrud({}, "create")}
									startIcon={<AddIcon />}
								>
									Nuevo
								</Button>
							</Grid>
							<Grid item xs={12} md={3} lg={2}>
								<Button
									sx={{ width: "100%", mr: 1 }}
									variant="outlined"
									size="small"
									onClick={handleLimpiar}
									startIcon={<CleaningServicesIcon />}
								>
									Limpiar
								</Button>
							</Grid>
							<Grid item xs={12} md={3} lg={2}>
								<Button
									sx={{ width: "100%" }}
									variant="contained"
									size="small"
									onClick={handleBuscar}
									startIcon={<SearchIcon />}
								>
									Buscar
								</Button>

							</Grid>
							<Grid item xs={12} md={3} lg={2} >
							</Grid>
							<Grid item xs={12} md={3} lg={2} >
							</Grid>
							{/* <Grid item xs={12} md={3} lg={2} >
								<Button
									sx={{ width: "100%" }}
									variant="contained"
                  							size="small"
									onClick={handleGenerarPDF}
									startIcon={<PictureAsPdfIcon />}
								>
									Generar PDF
								</Button>
							</Grid> */}
						</Grid>
					</Box>

					<Box sx={{ m: 1, p: 1 }}>
					</Box>
					{isDoingSomething && <LinearProgress />}

					<MUIDataTable
						columns={tableColumns}
						data={itemsCrud}
						options={tableOptions}
					/>

				</Box>
			</Paper>

			{/* >>>> Dialog */}

			{openDialog && (
				<SistemaRolOrganismoUsuarioDialog
					sistemas={sistemas}
					fueros={fueros}
					onSave={handleDialogSave}
					onClose={handleDialogClose}
					itemCrud={itemCrud}
					actionCrud={actionCrud}
					setMessage={setMessage}
					setShowMessage={setShowMessage}
				/>
			)}

			{/* >>>> Messages */}

			{showMessage && (
				<Message
					showMessage={showMessage}
					setShowMessage={setShowMessage}
					message={message}
				/>
			)}
		</>
	);
};

export default SistemaRolOrganismoUsuarioTable;
